import { login, getcode, next, reset } from '../../api/login'

const user = {
  state: {
    token: sessionStorage.getItem('token'),
    name: sessionStorage.getItem('user'),
    mobile: sessionStorage.getItem('phone'),
    menu: sessionStorage.getItem('menu')
  },
  mutations: {
    set_token(state, token) {
      state.token = token;
      sessionStorage.token = token
    },
    del_token(state) {
      state.token = '';
      sessionStorage.removeItem('token')
    },
    set_user(state, user) {
      state.name = user;
      sessionStorage.user = user
    },
    del_user(state) {
      state.name = '';
      sessionStorage.removeItem('user')
    },
    set_phone(state, phone) {
      state.mobile = phone;
      sessionStorage.phone = phone
    },
    del_phone(state) {
      state.phone = '';
      sessionStorage.removeItem('phone')
    },
    set_menu(state, menu) {
      state.menu = menu;
      sessionStorage.menu = menu;
    },
    del_menu(state) {
      state.menu = '';
      sessionStorage.removeItem('menu')
    },
  },
  actions: {
    // 登录
    login({ commit }, userInfo) {
      const username = userInfo.username;
      const password = userInfo.password;
      const phone = userInfo.phone;
      const code = userInfo.code;
      return new Promise((resolve, reject) => {
        login(username, password, phone, code).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取验证码
    getcode({ commit }, mobile) {
      return new Promise((resolve, reject) => {
        getcode(mobile).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 忘记密码下一步
    next({ commit }, userInfo) {
      const mobile = userInfo.mobile.trim();
      const code = userInfo.code.trim();
      return new Promise((resolve, reject) => {
        next(mobile, code).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 重置密码
    reset({ commit }, userInfo) {
      const mobile = userInfo.mobile.trim();
      const password = userInfo.password.trim();
      const password_confirmation = userInfo.password_confirmation.trim();
      return new Promise((resolve, reject) => {
        reset(mobile, password, password_confirmation).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
  }
};

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js